import { render } from "./AdminReports.vue?vue&type=template&id=98dcbf38&scoped=true"
import script from "./AdminReports.vue?vue&type=script&lang=js"
export * from "./AdminReports.vue?vue&type=script&lang=js"

import "./AdminReports.vue?vue&type=style&index=0&id=98dcbf38&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98dcbf38"]])

export default __exports__